import PropTypes from "prop-types";
import React from "react";

export default class WhatWereLoving extends React.PureComponent {
  static propTypes = {"wishlistCount": PropTypes.number.isRequired}

  render () {
    const {wishlistCount} = this.props;

    return (
      <div>
        { wishlistCount < 30 &&
          <div className="wishlist-count">
            <span className="psst">
              Psst!&nbsp;
            </span>
            <span>
              You&nbsp;
            </span>
            { wishlistCount ? (
              <span>
                only have&nbsp;
                {wishlistCount}
                &nbsp;
              </span>
            ) : (
              <span>
                don&apos;t have any&nbsp;
              </span>
            )
            }

            { wishlistCount === 1 ? (
              <span>
                item&nbsp;
              </span>
            ) : (
              <span>
                items&nbsp;
              </span>
            )
            }
            <span>
              on your Wish List.&nbsp;
              <a
                className="keep-wishlisting"
                href="/jewelry"
              >
                Keep Wishlisting &gt;
              </a>
            </span>
          </div>
        }
      </div>
    );
  }
}
